import { callApi } from "@src/api/callApi"
import { THEFT } from "@src/api/types"

export const getPartnerDeviceSerialnumberTheftsActive = (
  partnerUuid: string,
  serialnumber: string,
) =>
  callApi<null, THEFT>({
    method: "GET",
    path: `/partner/${partnerUuid}/device/${serialnumber}/thefts/active`,
  })
